import React, { useEffect, useState, useRef } from "react";
import validator from "validator";
import QuickActionsSidebar from "../DistributorDashboard/QuickActionsSidebar";
import { getAdminActions } from "../../../config/actions";
import { makeStyles } from "@material-ui/core/styles";
import { Link, Router, useLocation, useParams } from "react-router-dom";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  Typography,
} from "@material-ui/core";
import MaterialTable from "material-table";
import Top from "../Top";
import { API_URL } from "../../../config";
import { Button, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import logimg from "../../images/log.png";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GoDeviceDistributors from "../godevice/GoDeviceDistributors";
import GoDeviceDistributors6 from "../godevice/GoDeviceDistributors6";
import GoDeviceAccordian5 from "../godevice/GoDeviceAccordian5";
import AssignModuleModal from "./AssignModuleModal";
import AssignDeviceModal from "./AssignDeviceModal";
import AssignWarrantyModal from "./AssignWarrantyModal";
import AssignAccessoryModal from "./AssignAccessoryModal";
import TxnHistoryModal from "./TxnHistoryModal";
import Pagination from "../../common/Pagination";
import "./DistributorsAdd.css";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const DistributorsAdd = () => {
  const user_type = localStorage.getItem("user_type");
  const classes = useStyles();
  const navigation = useNavigate();
  const location = useLocation();

  const [data, setData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const DIST_PAGE_SIZE = 6;
  const [distCurrentPage, setDistCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [filterUserType, setFilterUserType] = useState("all");
  const [distId, setDistId] = useState(null);
  const [distributorName, setDistributorName] = useState("");
  const [customerDeviceModal, setCustomerDeviceModal] = useState(false);
  const CustomerDeviceToggleModal = () => {
    setCustomerDeviceModal(!customerDeviceModal);
    if (passShow) {
      setPassShow(!passShow);
    }
  };
  const [firstName1, setFirstName1] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [dataload, setDataload] = useState(false);
  const [password1, setPassword1] = useState("");
  const [telephone1, setTelephone1] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [age, setAge] = useState("");
  const [country, setCountry] = useState("");
  const [gender, setGender] = useState("");
  const [business, setBusiness] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [countryId, setCountryId] = useState("");
  const [state, setState] = useState("");
  const [stateId, setStateId] = useState("");
  const [popData1, setPopData1] = useState({});
  const [GoToggle, setGoToggle] = useState(false);
  const [Device5, setDevice5] = useState(false);
  const [Device6, setDevice6] = useState(false);
  const [passShow, setPassShow] = useState(false);

  const [cmoduleval, setCmoduleval] = useState(0);
  const [mmoduleval, setMmoduleval] = useState(0);
  const [serialkeyval, setSerialkeyval] = useState(null);
  const [confirmpasserror, setConfirmpasserror] = useState("");
  const [confirmSerialkeyval, setConfirmSerialkeyval] = useState("");
  const [devicetype, setDevicetype] = useState(0);
  const [checkingboxmessge, setCheckingboxmessge] = useState(false);

  const serialkey = useRef();
  const confirmserialkey = useRef();
  const device_type = useRef();
  const cmodule = useRef();
  const m_module = useRef();
  const [errorMessege, setErrorMessege] = useState(false);
  const [deviceid, setDeviceid] = useState(null);
  const [selSerialKey, setSelSerialKey] = useState(null);

  const [serialkeyes, setSerialkey] = useState(null);

  const [distributorDeviceModal, setdistributorDeviceModal] = useState(false);
  const [ownerDeviceModal, setownerDeviceModal] = useState(false);
  const distributorDeviceToggleModal = () => {
    setdistributorDeviceModal(!distributorDeviceModal);
  };
  const ownerDeviceToggleModal = () => {
    setownerDeviceModal(!ownerDeviceModal);
  };

  const [successModal, setSuccessModal] = useState(false);
const [addModuleModal, setAddModuleModal] = useState(false);
const [addWarrantyModal, setAddWarrantyModal] = useState(false);
const [addAccessoryModal, setAddAccessoryModal] = useState(false);
const [historyModal, setHistoryModal] = useState(false);
const [selectedDistributorId, setSelectedDistributorId] = useState(null);
const [purchasePricesModal, setPurchasePricesModal] = useState(false);
const [purchasePricesDistributorId, setPurchasePricesDistributorId] = useState(null);
const [purchasePrices, setPurchasePrices] = useState({ module: "", sensor: "", warranty: "" });
// Filled in by the "Set Default" button in the Set Purchase Prices modal.
const DEFAULT_PURCHASE_PRICES = { module: 110, sensor: 235, warranty: 100 };
const [purchasePricesLoading, setPurchasePricesLoading] = useState(false);
const [purchasePricesSaving, setPurchasePricesSaving] = useState(false);
  const [addDeviceModal, setAddDeviceModal] = useState(false);
  const [addSuccessModal, setAddSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [resetPricesModal, setResetPricesModal] = useState(false);
  const [resetPricesDistributorId, setResetPricesDistributorId] = useState(null);
  const [resetPricesLoading, setResetPricesLoading] = useState(false);
  const [resetPricesSuccessModal, setResetPricesSuccessModal] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const successToggleModal = () => setSuccessModal(!successModal);

  const [deleteModal, setDeleteModal] = useState(false);
  const deleteToggleModal = () => setDeleteModal(!deleteModal);

  const [deletesuccessModal, setDeletesuccessModal] = useState(false);
  const deletesuccessToggleModal = () =>
    setDeletesuccessModal(!deletesuccessModal);

  const [editdeviceModal, setEditdeviceModal] = useState(false);
  const editdeviceToggleModal = () => setEditdeviceModal(!editdeviceModal);

  const [successeditdeviceModal, setSuccesseditdeviceModal] = useState(false);
  const successeditdeviceToggleModal = () =>
    setSuccesseditdeviceModal(!successeditdeviceModal);

  const [deregistersuccessfulModal, setDeregistersuccessfulModal] =
    useState(false);
  const deregistersuccessfulToggleModal = () =>
    setDeregistersuccessfulModal(!deregistersuccessfulModal);

  const [devicekeyModal, setDevicekeyModal] = useState(false);
  const devicekeyToggleModal = () => setDevicekeyModal(!devicekeyModal);

  const [deregisterModal, setDeregisterModal] = useState(false);
  const deregisterToggleModal = () => setDeregisterModal(!deregisterModal);

  const [ViewdeviceModal, setViewdeviceModal] = useState(false);
  const viewdeviceToggleModal = () => setViewdeviceModal(!ViewdeviceModal);

  const [viewlinkedModal, setViewlinkedModal] = useState(false);
  const ViewlinkedToggleModal = () => setViewlinkedModal(!viewlinkedModal);

  const userid = localStorage.getItem("user_id");
  const [fetchdata, setFetchdata] = useState(true);

  useEffect(() => {
    godevicelist();
  }, []);

  useEffect(() => {
    applyFiltersAndSort();
  }, [rawData, searchTerm, sortField, sortOrder, filterUserType]);

  const applyFiltersAndSort = () => {
    let filtered = [...rawData];

    // Apply search filter
    if (searchTerm) {
      filtered = filtered.filter(
        (dist) =>
          dist.firstname.toLowerCase().includes(searchTerm.toLowerCase()) ||
          dist.lastname.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Apply user type filter
    if (filterUserType !== "all") {
      filtered = filtered.filter((dist) => dist.user_type_label === filterUserType);
    }

    // Apply sorting
    filtered.sort((a, b) => {
      let aVal, bVal;

      if (sortField === "firstname") {
        aVal = a.firstname.toLowerCase();
        bVal = b.firstname.toLowerCase();
      } else if (sortField === "lastname") {
        aVal = a.lastname.toLowerCase();
        bVal = b.lastname.toLowerCase();
      }

      if (sortOrder === "asc") {
        return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
      } else {
        return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
      }
    });

    setFilteredData(filtered);
    setDistCurrentPage(1);
  };

  const HandleCmodule = () => {
    if (cmodule.current.checked) {
      setCmoduleval(1);
    } else {
      setCmoduleval(0);
    }
  };
  const handleGoToggle = () => {
    setGoToggle(true);
  };
  const handleDevice5 = () => {
    setDevice5(true);
  };
  const handleDevice6 = () => {
    setDevice6(true);
  };

  const HandlemModule = () => {
    if (m_module.current.checked) {
      setMmoduleval(1);
    } else {
      setMmoduleval(0);
    }
  };
  const handleDistributor = (event, id) => {
    setDistributorName(event);
    setDistId(id);
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setPostalCode("");
    setCountryId("");
    setState("");
    setBusiness("");
    const url = `/get/distributer/device/by/${id}`;
    fetch(API_URL + `${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setPopData1(resp);
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname == null ? "NA" : item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(item.address == null ? "NA" : item.address);
            setAddress2(item?.address2 == null ? "NA" : item.address2);
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            setCity(item.city == null ? "NA" : item.city);
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
            setCountryId(item.country == null ? "NA" : item.country);
            setBusiness(item.business == null ? "NA" : item.business);
            setStateId(item.state == null ? "NA" : item.state);
            setPostalCode(item.zipcode == null ? "NA" : item.zipcode);
            getCountry(item.country);
            getState(item.country, item.state);
          });
        });
      }
    });
  };
  const handleOwner = (event, id) => {
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setCountry("");
    setAge("");
    setGender("");
    const params = { associated_owner: id };
    setDistributorName(event);
    const url = `/get/owner/device/by/${id}`;
    fetch(API_URL + url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setPopData1(resp);
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(
              item.address == null || item.address.length == 0
                ? "NA"
                : item.address
            );
            setAddress2(item.address2 == null ? "NA" : item.address2);
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            setCity(item.city.length == 0 ? "NA" : item.city);
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
            setCountryId(item.country == null ? "NA" : item.country);
            setBusiness(item.business == null ? "NA" : item.business);
            setStateId(item.state == null ? "NA" : item.state);
            setPostalCode(item.zipcode == null ? "NA" : item.zipcode);
            getCountry(item.country);
            getState(item.country, item.state);
          });
        });
      }
    });
  };

  const getCountry = (countryid) => {
    setCountry("");
    if (countryid == "") {
      setCountry("NA");
    } else {
      fetch(API_URL + "/countries", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            resp.countries.map((item) => {
              if (item.id == countryid) {
                setCountry(item.name == null ? "NA" : item.name);
              }
            });
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      });
    }
  };

  const getState = (countryid, stateid) => {
    setState("");
    if (countryid == "" || stateid == null) {
      if (stateid == null || stateid == "") {
        setState("NA");
      } else if (stateid.includes("Choose States/Province")) {
        setState("NA");
      } else {
        setState(stateid);
      }
    } else {
      fetch(API_URL + "/states?country_id=" + countryid, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        if (response.status == 200) {
          response.json().then((resp) => {
            resp.states.map((item) => {
              if (item.id == stateid) {
                setState(item.name);
              }
            });
          });
        } else if (response.status == 401) {
          logout();
        } else {
          console.log("network error");
        }
      });
    }
  };

  const SaveDevice = () => {
    let data = {};

    if (
      validator.trim(serialkey.current.value) == "" ||
      device_type.current.value == "null"
    ) {
      setErrorMessege(true);
      return false;
    }

    data["serial_key"] = validator.trim(serialkey.current.value);
    data["distributer"] = userid;
    data["device_type"] = device_type.current.value;
    data["c_module"] = cmoduleval;
    data["m_module"] = mmoduleval;

    fetch(API_URL + "/create/device", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          deviceToggleModal();
          successToggleModal();
          godevicelist();
          setCmoduleval(0);
          setMmoduleval(0);
        });
      } else if (response.status == 400) {
        devicekeyToggleModal();
      } else {
        alert("network error");
      }
    });
  };
  const handleDistributorView = (event) => {
    setDistId(event);
    setDataload(true);
    setFirstName1("");
    setLastName("");
    setPassword1("");
    setEmail("");
    setAddress1("");
    setAddress2("");
    setTelephone1("");
    setCity("");
    setPostalCode("");
    setCountryId("");
    setState("");
    setBusiness("");
    fetch(API_URL + `/get/distributer/device/v2/by/${event}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          resp.data.profile.map((item) => {
            setFirstName1(item.firstname == null ? "NA" : item.firstname);
            setLastName(item.lastname == null ? "NA" : item.lastname);
            setPassword1(item.password == null ? "NA" : item.password);
            setEmail(item.email == null ? "NA" : item.email);
            setAddress1(item.address == null ? "NA" : item.address);
            setAddress2(item?.address2 == null ? "NA" : item.address2);
            setTelephone1(item.telephone == null ? "NA" : item.telephone);
            setCity(item.city == null ? "NA" : item.city);
            setAge(item.age == null ? "NA" : item.age);
            setGender(item.gender == null ? "NA" : item.gender);
            setCountryId(item.country == null ? "NA" : item.country);
            setBusiness(item.business == null ? "NA" : item.business);
            setStateId(item.state == null ? "NA" : item.state);
            setPostalCode(item.zipcode == null ? "NA" : item.zipcode);
            getCountry(item.country);
            getState(item.country, item.state);
          });
          setDataload(false);
        });
      }
    });
  };

  const godevicelist = () => {
    fetch(API_URL + "/get/all/distributer/v2", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          let _temp = [];
          let _rawData = [];

          resp.data
            .filter((v) => v.user_type !== 8)
            .map((v, i) => {
              if(uid == v.id){
                return ;
              }
              // console.log(v.user_type, typeof v.user_type);
              const userTypeLabel = v.user_type == 7
                ? "Admin"
                : v.user_type == 8
                ? "Tech Support"
                : "Distributor";

              _rawData.push({
                id: v.id,
                eid: v.eid,
                name: v.firstname == null ? "NA" : v.lastname + " " + v.firstname,
                firstname: v.firstname == null ? "NA" : v.firstname,
                lastname: v.lastname == null ? "NA" : v.lastname,
                email: v.email == null ? "NA" : v.email,
                user_type_label: userTypeLabel,
                user_type_raw: v.user_type,
                date_activated: v.date_activated,
                serial_key: v.serial_key,
                devices: v.device_count,
                modules: v.module_count,
                sensors: v.sensor_count,
                warranties: v.warranty_count,
              });

              _temp.push({
                distributor:
                  v.firstname == null ? "NA" : v.lastname + " " + v.firstname,
                email: v.email == null ? "NA" : v.email,
                user_type:
                  v.user_type == null
                    ? "NA"
                    : v.user_type == 7
                    ? "Admin"
                    : v.user_type == 8
                    ? "Tech Support"
                    : "Distributor",

                action: (
                  <ul className="action-list">
                    <li>
                      {v.date_activated == 0 || v.date_activated == null ? (
                        <>
                          {user_type != 8 && (
                            <Tooltip
                              classes={{
                                tooltip: classes.customTooltip,
                              }}
                              title="Edit"
                              placement="top"
                            >
                              <Link
                                to={"/edit/distributor/" + v.id}
                                className="view-patient"
                              >
                                <i
                                  className="fa fa-pencil-square-o"
                                  aria-hidden="true"
                                ></i>
                              </Link>
                            </Tooltip>
                          )}{" "}
                          <>
                            {user_type != 8 && (
                              <Tooltip
                                classes={{
                                  tooltip: classes.customTooltip,
                                }}
                                title="Delete"
                                placement="top"
                              >
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => deleteItempopUp(v.id)}
                                  className="view-patient"
                                >
                                  <i
                                    className="fa fa-trash"
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </Tooltip>
                            )}{" "}
                          </>
                          <Tooltip
                            classes={{
                              tooltip: classes.customTooltip,
                            }}
                            title="View"
                            placement="top"
                          >
                            <a
                              href="javascript:void(0)"
                              onClick={() => {
                                handleDistributorView(v.eid);
                                setCustomerDeviceModal(!customerDeviceModal);
                              }}
                              className="view-patient"
                            >
                          
                              <i className="fa fa-eye" aria-hidden="true"></i>
                            </a>
                          </Tooltip>
                           {user_type != 8 && (
                            <Tooltip
                              classes={{
                                tooltip: classes.customTooltip,
                              }}
                              title="Add Modules"
                              placement="top"
                            >
                                <a
                              href="javascript:void(0)"
                              onClick={() => {
                                 setSelectedDistributorId(v.eid);
      setAddModuleModal(true);
                              }}
                              className="view-patient"
                            >
                                   <i className="fa fa-cubes" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                           {user_type != 8 && (
                            <Tooltip
                              classes={{
                                tooltip: classes.customTooltip,
                              }}
                              title="Add Devices"
                              placement="top"
                            >
                                <a
                              href="javascript:void(0)"
                              onClick={() => {
                                setSelectedDistributorId(v.eid);
                                setAddDeviceModal(true);
                              }}
                              className="view-patient"
                            >
                              <i className="fa fa-plus-circle" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                          {user_type != 8 && (
                            <Tooltip
                              classes={{
                                tooltip: classes.customTooltip,
                              }}
                              title="Reset Prices"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  setResetPricesDistributorId(v.eid);
                                  setResetPricesModal(true);
                                }}
                                className="view-patient"
                              >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                          {user_type != 8 && (
                            <Tooltip
                              classes={{ tooltip: classes.customTooltip }}
                              title="Set Purchase Prices"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  setPurchasePricesDistributorId(v.eid);
                                  setPurchasePricesModal(true);
                                }}
                                className="view-patient"
                              >
                                <i className="fa fa-dollar" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                          {user_type != 8 && (
                            <Tooltip
                              classes={{ tooltip: classes.customTooltip }}
                              title="Assign Warranty"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  setSelectedDistributorId(v.eid);
                                  setAddWarrantyModal(true);
                                }}
                                className="view-patient"
                              >
                                <i className="fa fa-shield" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                          {user_type != 8 && (
                            <Tooltip
                              classes={{ tooltip: classes.customTooltip }}
                              title="Assign Sensors"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  setSelectedDistributorId(v.eid);
                                  setAddAccessoryModal(true);
                                }}
                                className="view-patient"
                              >
                                <i className="fa fa-life-ring" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                          {user_type != 8 && (
                            <Tooltip
                              classes={{ tooltip: classes.customTooltip }}
                              title="Txn History"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => {
                                  setSelectedDistributorId(v.eid);
                                  setHistoryModal(true);
                                }}
                                className="view-patient"
                              >
                                <i className="fa fa-history" aria-hidden="true"></i>
                              </a>
                            </Tooltip>
                          )}
                        </>
                      ) : (
                        <>
                          {user_type != 8 && (
                            <Tooltip
                              classes={{
                                tooltip: classes.customTooltip,
                              }}
                              title="De-register"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() =>
                                  deRegisterpopup(v.id, v.serial_key)
                                }
                                className="view-patient"
                              >
                                <i
                                  className="fa fa-user-times"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </Tooltip>
                          )}
                        </>
                      )}
                    </li>
                  </ul>
                ),
              });
            });
          setFetchdata(false);
          setData(_temp.sort());
          setRawData(_rawData);
        });
      }
    });
  };

  const deleteItempopUp = (id) => {
    if (deleteModal == false) {
      setDeviceid(id);
      setDeleteModal(!deleteModal);
    } else {
      setDeviceid(id);
      setDeleteModal(deleteModal);
    }
  };

  const edittempopUp = (id) => {
    setDeviceid(id);
    setEditdeviceModal(!editdeviceModal);
  };

  const viewdevicepopup = (key) => {
    setSerialkey(key);
    setViewdeviceModal(!ViewdeviceModal);
  };

  const viewlinkedpopup = (key) => {
    setSerialkey(key);
    setViewlinkedModal(!viewlinkedModal);
  };

  const deleteDevice = () => {
    fetch(API_URL + "/delete/distributer/v2/profile/by/" + deviceid, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          godevicelist();
          deleteToggleModal();
          deletesuccessToggleModal();
        });
      } else {
        alert("Network error");
      }
    });
  };

  const chackValidationserialkey = () => {
    if (serialkeyval != confirmserialkey.current.value) {
      setConfirmpasserror("Serial key should match");
    } else {
      setConfirmpasserror("");
    }

    setConfirmSerialkeyval(confirmserialkey.current.value);
  };

  const HandleSerialkey = () => {
    if (confirmSerialkeyval != serialkey.current.value) {
      setConfirmpasserror("Serial key should match");
    } else {
      setConfirmpasserror("");
    }

    setSerialkeyval(serialkey.current.value);

    var val = serialkey.current.value;
    if (val == 0) {
      setErrorMessege(true);
    } else {
      setErrorMessege(false);
    }
  };

  const HandledeviceType = () => {
    var val = device_type.current.value;

    setDevicetype(device_type.current.value);

    setCmoduleval(0);
    setMmoduleval(0);

    if (val == 5) {
      setCheckboxshow(true);
      setCheckingboxmessge(true);
    } else {
      setCheckboxshow(false);
      setCheckingboxmessge(false);
    }

    if (val == "null") {
      setErrorMessege(true);
    } else {
      setErrorMessege(false);
    }
  };

  const deRegisterpopup = (id, _serial) => {
    setDeviceid(id);
    setSelSerialKey(_serial);
    setDeregisterModal(!deregisterModal);
  };

  const deregister = () => {
    let data = {};

    data["serial_key"] = selSerialKey;
    data["user"] = userid;

    fetch(API_URL + "/add/device/seven/history/" + deviceid, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          godevicelist();
          deregistersuccessfulToggleModal();
          deregisterToggleModal();
        });
      } else if (response.status == 400) {
        devicekeyToggleModal();
      } else {
        alert("network error");
      }
    });
  };

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleResetPrices = () => {
    setResetPricesLoading(true);
    fetch(API_URL + `/distributor/reset-prices/${resetPricesDistributorId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        setResetPricesLoading(false);
        if (response.status === 200) {
          setResetPricesModal(false);
          setResetPricesSuccessModal(true);
        } else {
          alert("Failed to reset prices. Please try again.");
        }
      })
      .catch(() => {
        setResetPricesLoading(false);
        alert("Network error");
      });
  };

  const columns = [
    {
      title: "Name",
      field: "distributor",
    },
    {
      title: "Email",
      field: "email",
      width: "200px",
      customSort: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "User Type",
      field: "user_type",
      width: "200px",
    },
    {
      title: <span className="text-right">Action</span>,
      field: "action",
    },
  ];

  const handleDeviceSerial = () => {
    navigation("/add-distributor");
  };
  const handleTechSupport = () => {
    navigation("/tech-support");
  };

  const handleGoDevice = () => {
    navigation("/");
  };
  const handleDevice = () => {
    navigation("/maintenance7");
  };
  const handleShowPassword = () => {
    setPassShow(!passShow);
  };

  const uid = localStorage.getItem("uid");
  const userId = localStorage.getItem("user_id");

  const adminActions = getAdminActions("7", userId);

  const distTotalPages = Math.max(
    1,
    Math.ceil(filteredData.length / DIST_PAGE_SIZE)
  );
  const paginatedDistributors = filteredData.slice(
    (distCurrentPage - 1) * DIST_PAGE_SIZE,
    distCurrentPage * DIST_PAGE_SIZE
  );

  return (
    <div className="distributors-add-container">
      <div className="distributors-add-dashboard">
        <QuickActionsSidebar actions={adminActions} expandedMenu={expandedMenu} setExpandedMenu={setExpandedMenu} />
        <div className="distributors-add-content">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="head-listing">
              <h3>Distributors </h3>
            </div>
            {user_type != 8 && (
              <div
                className="add-btn"
                style={{
                  display: "flex",
                  gap: "15px",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={() => {
                    handleDeviceSerial();
                  }}
                >
                  Add Distributor
                </button>
                {/* <button
                  style={{ margin: "0" }}
                  onClick={() => {
                    handleTechSupport();
                  }}
                >
                  Tech Support Executive
                </button> */}
              </div>
            )}
          </div>
          {/* Filters Section */}
          <div className="filters-section">
            <div className="filter-group">
              <label>Sort by:</label>
              <div className="sort-controls-inline">
                <select
                  value={sortField}
                  onChange={(e) => setSortField(e.target.value)}
                >
                  <option value="lastname">Last Name</option>
                  <option value="firstname">First Name</option>
                </select>
                <button
                  className={`sort-order-btn ${sortOrder}`}
                  onClick={() =>
                    setSortOrder(sortOrder === "asc" ? "desc" : "asc")
                  }
                  title="Toggle sort direction"
                >
                  {sortOrder === "asc" ? "ASC" : "DESC"}
                </button>
              </div>
            </div>

            <div className="search-box">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Search by name or email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="filters-header">
              <span className="filters-label">Filters</span>
              <button
                className="clear-filters-btn"
                onClick={() => {
                  setFilterUserType("all");
                  setSearchTerm("");
                }}
              >
                Clear
              </button>
            </div>

            <div className="filter-controls">
              <div className="filter-group">
                <label>Filter by User Type:</label>
                <select
                  value={filterUserType}
                  onChange={(e) => setFilterUserType(e.target.value)}
                >
                  <option value="all">All User Types</option>
                  <option value="Admin">Admin</option>
                  <option value="Distributor">Distributor</option>
                </select>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="distributors-table-section">
            {fetchdata ? (
              <div className="loading-state">
                <div className="loader-spinner"></div>
                <p>Loading distributors...</p>
              </div>
            ) : filteredData.length === 0 ? (
              <div className="empty-state">
                <i className="fas fa-inbox"></i>
                <p>No distributors found</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <table className="distributors-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>User Type</th>
                      <th>Devices</th>
                      <th>Modules</th>
                      <th>Sensors</th>
                      <th>Warranty</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedDistributors.map((dist) => {
                      const avatarChar = dist.name.charAt(0).toUpperCase();
                      return (
                        <tr key={dist.id}>
                          <td>
                            <div className="distributor-name">
                              <span className="distributor-avatar">
                                {avatarChar}
                              </span>
                              <div>
                                <div>{dist.name}</div>
                                {/* <div style={{ fontSize: "12px", color: "#999" }}>Id: {dist.eid}</div> */}
                              </div>
                            </div>
                          </td>
                          <td className="distributor-email">{dist.email}</td>
                          <td>
                            <span className={`user-type-badge ${dist.user_type_label.toLowerCase().replace(/\s+/g, '-')}`}>
                              {dist.user_type_label}
                            </span>
                          </td>
                          <td>
                            <span className="count-badge">{dist.devices}</span>
                          </td>
                          <td>
                            <span className="count-badge">{dist.modules}</span>
                          </td>
                          <td>
                            <span className="count-badge">{dist.sensors}</span>
                          </td>
                          <td>
                            <span className="count-badge">{dist.warranties}</span>
                          </td>
                          <td>
                            <div className="dist-action-buttons">
                              {dist.date_activated == 0 || dist.date_activated == null ? (
                                <>
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Edit"
                                      placement="top"
                                    >
                                      <Link
                                        to={"/edit/distributor/" + dist.id}
                                        className="action-btn view-btn"
                                      >
                                        <i className="fa fa-pencil-square-o"></i>
                                      </Link>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Delete"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => deleteItempopUp(dist.id)}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  <Tooltip
                                    classes={{ tooltip: classes.customTooltip }}
                                    title="View"
                                    placement="top"
                                  >
                                    <a
                                      href="javascript:void(0)"
                                      onClick={() => {
                                        handleDistributorView(dist.eid);
                                        setCustomerDeviceModal(!customerDeviceModal);
                                      }}
                                      className="action-btn view-btn"
                                    >
                                      <i className="fa fa-eye"></i>
                                    </a>
                                  </Tooltip>
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Add Modules"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setSelectedDistributorId(dist.eid);
                                          setAddModuleModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-cubes"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Add Devices"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setSelectedDistributorId(dist.eid);
                                          setAddDeviceModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-plus-circle"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Reset Prices"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setResetPricesDistributorId(dist.eid);
                                          setResetPricesModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-refresh"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Set Purchase Prices"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setPurchasePricesDistributorId(dist.eid);
                                          setPurchasePricesModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-dollar"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Assign Warranty"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setSelectedDistributorId(dist.eid);
                                          setAddWarrantyModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-shield"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Assign Sensors"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setSelectedDistributorId(dist.eid);
                                          setAddAccessoryModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-life-ring"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="Txn History"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          setSelectedDistributorId(dist.eid);
                                          setHistoryModal(true);
                                        }}
                                        className="action-btn"
                                      >
                                        <i className="fa fa-history"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                </>
                              ) : (
                                <>
                                  {user_type != 8 && (
                                    <Tooltip
                                      classes={{ tooltip: classes.customTooltip }}
                                      title="De-register"
                                      placement="top"
                                    >
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() =>
                                          deRegisterpopup(dist.id, dist.serial_key)
                                        }
                                        className="action-btn"
                                      >
                                        <i className="fa fa-user-times"></i>
                                      </a>
                                    </Tooltip>
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
            {!fetchdata && filteredData.length > 0 && (
              <Pagination
                currentPage={distCurrentPage}
                totalPages={distTotalPages}
                onPageChange={setDistCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

<AssignModuleModal
  addModuleModal={addModuleModal}
  setAddModuleModal={setAddModuleModal}
  distributorId={selectedDistributorId}
  setSuccessModal={setAddSuccessModal}
  setSuccessMessage={setSuccessMessage}
  godevicelist={godevicelist}
/>

<AssignDeviceModal
  addDeviceModal={addDeviceModal}
  setAddDeviceModal={setAddDeviceModal}
  distributorId={selectedDistributorId}
  setSuccessModal={setAddSuccessModal}
  setSuccessMessage={setSuccessMessage}
  godevicelist={godevicelist}
/>

<AssignWarrantyModal
  addWarrantyModal={addWarrantyModal}
  setAddWarrantyModal={setAddWarrantyModal}
  distributorId={selectedDistributorId}
  setSuccessModal={setAddSuccessModal}
  setSuccessMessage={setSuccessMessage}
  godevicelist={godevicelist}
/>

<AssignAccessoryModal
  addAccessoryModal={addAccessoryModal}
  setAddAccessoryModal={setAddAccessoryModal}
  distributorId={selectedDistributorId}
  setSuccessModal={setAddSuccessModal}
  setSuccessMessage={setSuccessMessage}
  godevicelist={godevicelist}
/>

<TxnHistoryModal
  historyModal={historyModal}
  setHistoryModal={setHistoryModal}
  distributorId={selectedDistributorId}
/>

<Modal
  isOpen={addSuccessModal}
  toggle={() => setAddSuccessModal(false)}
  centered
>
  <ModalBody className="text-center">
    <div style={{ fontSize: "40px", color: "rgb(77, 0, 77)" }}>✔</div>

    <h5 className="mt-2">{successMessage}</h5>

    <button
      className="btn btn-success mt-3"
      style={{ backgroundColor: "rgb(77, 0, 77)", borderColor: "rgb(77, 0, 77)" }}
      onClick={() => setAddSuccessModal(false)}
    >
      OK
    </button>
  </ModalBody>
</Modal>
      <Modal
        isOpen={successModal}
        toggle={successToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successToggleModal}>
          <span className="ml-1 roititle text-white">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Serial key has been added successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deleteModal}
        toggle={deleteToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalBody>
          <div className="deletemodal-content">
            <h6>
              <i
                onClick={() => setDeleteModal(false)}
                className="fa fa-times"
                aria-hidden="true"
              ></i>
            </h6>
            <div className="deleteCircle">
              <i className="fa fa-trash" aria-hidden="true"></i>
            </div>
            <h3>Are you sure?</h3>
            <p className="para">
              Do you really want to delete the record? This process cannot be
              undone.
            </p>

            <div className="butn-wrp">
              <button className="delete-cancel-btn" onClick={deleteToggleModal}>
                Cancel
              </button>
              <button onClick={deleteDevice}>Delete</button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={deletesuccessModal}
        toggle={deletesuccessToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={deletesuccessToggleModal}>
          <span className="ml-1 roititle text-white">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Distributer Profile has been deleted successfully</p>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={editdeviceModal}
        toggle={editdeviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={editdeviceToggleModal}>
          <span className="ml-1 roititle ">Edit</span>
        </ModalHeader>
        <ModalBody>
          Do you want to edited some thing?
          {/* <EditDevice deviceid={deviceid} editdeviceToggleModal={editdeviceToggleModal} successeditdeviceToggleModal={successeditdeviceToggleModal} godevicelist={godevicelist} devicekeyToggleModal={devicekeyToggleModal} /> */}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={successeditdeviceModal}
        toggle={successeditdeviceToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successeditdeviceToggleModal}>
          <span className="ml-1 roititle text-white">Successfull</span>
        </ModalHeader>
        <ModalBody>
          <div className="modal-paragrph">
            <p>Device type has been updated successfully</p>
          </div>
        </ModalBody>
      </Modal>
      {/* Reset Prices Confirmation Modal */}
      <Modal
        isOpen={resetPricesModal}
        toggle={() => !resetPricesLoading && setResetPricesModal(false)}
        className="connect-box"
        centered={true}
      >
        <ModalBody>
          <div className="deletemodal-content">
            <h6>
              <i
                onClick={() => !resetPricesLoading && setResetPricesModal(false)}
                className="fa fa-times"
                aria-hidden="true"
              ></i>
            </h6>
            <div className="resetCircle">
              <i className="fa fa-refresh" aria-hidden="true"></i>
            </div>
            <h3>Are you sure?</h3>
            <p className="para">
              Do you really want to reset this distributor's prices to default?
              This will overwrite any custom pricing that has been set.
            </p>
            <div className="butn-wrp" style={{justifyContent:"center",gap:"10px"}}>
              <button
                className="delete-cancel-btn"
                onClick={() => setResetPricesModal(false)}
                disabled={resetPricesLoading}
              >
                Cancel
              </button>
              <button
                onClick={handleResetPrices}
                disabled={resetPricesLoading}
                style={{ background: "rgb(77, 0, 77)", borderColor: "rgb(77, 0, 77)" }}
              >
                {resetPricesLoading ? "Resetting..." : "Reset Prices"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Set Purchase Prices Modal */}
      <Modal
        isOpen={purchasePricesModal}
        toggle={() => !purchasePricesSaving && setPurchasePricesModal(false)}
        centered
        onOpened={async () => {
          if (!purchasePricesDistributorId) return;
          setPurchasePricesLoading(true);
          try {
            const res = await fetch(`${API_URL}/distributor/purchase/prices/${purchasePricesDistributorId}`);
            const data = await res.json();
            if (data.status) {
              setPurchasePrices({
                module: data.module_and_accessories.module ?? "",
                sensor: data.module_and_accessories.sensor ?? "",
                warranty: data.module_and_accessories.warranty ?? "",
              });
            }
          } catch (err) {
            console.error("Error fetching purchase prices:", err);
          } finally {
            setPurchasePricesLoading(false);
          }
        }}
      >
        <ModalHeader
          toggle={() => !purchasePricesSaving && setPurchasePricesModal(false)}
          className="text-white"
        >
          <i className="fa fa-dollar"></i> Set Purchase Prices
        </ModalHeader>
        <ModalBody>
          {purchasePricesLoading ? (
            <div className="text-center py-4">
              <i className="fa fa-spinner fa-spin fa-2x" style={{ color: "rgb(77, 0, 77)" }}></i>
              <p className="mt-2">Loading prices...</p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              <div>
                <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                  <i className="fa fa-cubes" style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}></i>
                  Module Price ($)
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={purchasePrices.module}
                  onChange={(e) => setPurchasePrices((p) => ({ ...p, module: e.target.value }))}
                  placeholder="e.g. 110"
                  style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
              <div>
                <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                  <i className="fa fa-microchip" style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}></i>
                  Sensor Price ($)
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={purchasePrices.sensor}
                  onChange={(e) => setPurchasePrices((p) => ({ ...p, sensor: e.target.value }))}
                  placeholder="e.g. 235"
                  style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
              <div>
                <label style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}>
                  <i className="fa fa-shield" style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}></i>
                  Warranty Price ($)
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={purchasePrices.warranty}
                  onChange={(e) => setPurchasePrices((p) => ({ ...p, warranty: e.target.value }))}
                  placeholder="e.g. 100"
                  style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                />
              </div>
            </div>
          )}
        </ModalBody>
        <ModalBody style={{ borderTop: "1px solid #dee2e6", display: "flex", justifyContent: "flex-end", gap: "10px", padding: "12px 16px" }}>
          <button
            className="btn"
            style={{ background: "#ccc", color: "#333" }}
            onClick={() => setPurchasePricesModal(false)}
            disabled={purchasePricesSaving}
          >
            Cancel
          </button>
          <button
            className="btn"
            style={{ background: "white", color: "rgb(77, 0, 77)", border: "1px solid rgb(77, 0, 77)", boxShadow: "none" }}
            // Keep a mouse click from focusing it (no focus border)
            onMouseDown={(e) => e.preventDefault()}
            // Own hover colours — the global .btn:hover turns the text white,
            // which disappears on this white button.
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgb(77, 0, 77)";
              e.currentTarget.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "white";
              e.currentTarget.style.color = "rgb(77, 0, 77)";
            }}
            onClick={() => setPurchasePrices({ ...DEFAULT_PURCHASE_PRICES })}
            disabled={purchasePricesSaving || purchasePricesLoading}
          >
            Set Default
          </button>
          <button
            className="btn"
            style={{ background: "rgb(77, 0, 77)", color: "white" }}
            disabled={purchasePricesSaving || purchasePricesLoading}
            onClick={async () => {
              setPurchasePricesSaving(true);
              try {
                const res = await fetch(`${API_URL}/distributor/purchase/prices/${purchasePricesDistributorId}`, {
                  method: "PUT",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    module: Number(purchasePrices.module) || 0,
                    sensor: Number(purchasePrices.sensor) || 0,
                    warranty: Number(purchasePrices.warranty) || 0,
                  }),
                });
                const data = await res.json();
                if (data.status) {
                  setPurchasePricesModal(false);
                  setAddSuccessModal(true);
                  setSuccessMessage("Purchase prices updated successfully!");
                }
              } catch (err) {
                console.error("Error saving purchase prices:", err);
              } finally {
                setPurchasePricesSaving(false);
              }
            }}
          >
            {purchasePricesSaving ? "Saving..." : "Save Prices"}
          </button>
        </ModalBody>
      </Modal>

      {/* Reset Prices Success Modal */}
      <Modal
        isOpen={resetPricesSuccessModal}
        toggle={() => setResetPricesSuccessModal(false)}
        centered
      >
        <ModalBody className="text-center">
          <div style={{ fontSize: "40px", color: "rgb(77, 0, 77)" }}>✔</div>
          <h5 className="mt-2">Prices reset to default successfully</h5>
          <button
            className="btn btn-success mt-3"
            style={{ backgroundColor: "rgb(77, 0, 77)", borderColor: "rgb(77, 0, 77)" }}
            onClick={() => setResetPricesSuccessModal(false)}
          >
            OK
          </button>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={customerDeviceModal}
        toggle={CustomerDeviceToggleModal}
        className="connect-box1"
        centered={true}
      >
        <ModalHeader className="text-white" toggle={CustomerDeviceToggleModal}>
          Distributor Profile
        </ModalHeader>
        {dataload ? (
          <div className="loader12"></div>
        ) : (
          <div
            style={{ borderBottom: "1px solid #212529", paddingBottom: "40px" }}
          >
            <div className="row-main" style={{ padding: "0 15px" }}>
              <div className="row pt-3">
                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <div>
                    <div>
                      <div className="modal_p">
                        <p className="font14 heading_p"> First Name : </p>
                        <p className="font14">{firstName1} </p>
                      </div>
                      <div className="modal_p">
                        <p className="font14 heading_p"> Last Name : </p>
                        <p className="font14">{lastName} </p>
                      </div>

                      <div className="modal_p">
                        <p className="font14 heading_p"> Email : </p>
                        <p className="font14 add_p">
                          {email != "NA" ? email : "NA"}
                        </p>
                      </div>
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p"> Password : </p>

                          {password1 != "NA" ? (
                            <p
                              className="font14"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "35px",
                              }}
                            >
                              {passShow ? (
                                password1
                              ) : (
                                <div style={{ display: "flex" }}>
                                  {[...Array(password1.length)].map(
                                    (_, index) => (
                                      <div key={index} className="ball" />
                                    )
                                  )}
                                </div>
                              )}
                              <i
                                className={
                                  passShow
                                    ? "fa-solid fa-eye eyeColor"
                                    : "fa-solid fa-eye-slash eyeColor"
                                }
                                onClick={handleShowPassword}
                              ></i>
                            </p>
                          ) : (
                            <p
                              className="font14"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "35px",
                              }}
                            >
                              {password1}
                            </p>
                          )}
                        </div>
                      )}
                      <div className="modal_p">
                        <p className="font14 heading_p"> Telephone : </p>
                        <p className="font14">
                          {/* {telephone1.length == 0 ? "NA" : telephone1} */}
                          {telephone1 != "NA" ? telephone1 : "NA"}
                        </p>
                      </div>
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p"> Age : </p>
                          <p className="font14"> {age} </p>
                        </div>
                      )}
                      {user_type != 8 && (
                        <div className="modal_p">
                          <p className="font14 heading_p">
                            {" "}
                            Name of Business :{" "}
                          </p>
                          <p className="font14 add_p">
                            {" "}
                            {business.length == 0 ? "NA" : business}
                          </p>
                        </div>
                      )}
                    </div>
                    <div></div>
                  </div>
                </div>
                {user_type == 8 ? (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div className="modal_p">
                      <p className="font14 heading_p"> Gender : </p>
                      <p className="font14"> {gender}</p>
                    </div>
                    <div className="modal_p">
                      <p className="font14 heading_p"> Country : </p>
                      <p className="font14">{country}</p>
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <div>
                      <div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> City : </p>
                          <p className="font14">{city}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Postal Code : </p>
                          <p className="font14">
                            {postalCode.length == 0 ? "NA" : postalCode}
                          </p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Gender : </p>
                          <p className="font14"> {gender}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Country : </p>
                          <p className="font14">{country}</p>
                        </div>

                        <div className="modal_p ">
                          <p className="font14 heading_p"> State : </p>
                          <p className="font14"> {state}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Address 1 :</p>
                          <p className="font14 add_p">{address1}</p>
                        </div>
                        <div className="modal_p">
                          <p className="font14 heading_p"> Address 2 : </p>
                          <p className="font14 add_p">
                            {address2.length == 0 ? "NA" : address2}
                          </p>
                        </div>
                      </div>
                      <div></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* <ModalBody> */}
          {/* <div className="add-btn-wrp add-btn-wrp2">
            <div className="button-div">
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device GO</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceDistributors id={distId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 6.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceDistributors6 id={distId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion className="main-accordian">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Device 5.0</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <GoDeviceAccordian5 id={distId} />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          </div> */}
        {/* </ModalBody> */}
      </Modal>
    </div>
  );
};

export default DistributorsAdd;
